/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AnyDataObjectId,
  DataSource,
  MapDataSourceArrayEnrichedDataObjectMetadataView,
  MapDataSourceArrayFieldOperators,
  MapDataSourceArrayLimitedDataObjectMetadataView,
  MapString,
} from "./data-contracts";
import { FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V2<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "rules";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description list available fields for specified sources and objects
   *
   * @tags Fields V2
   * @name ListFieldsForSpecifiedObjects
   * @request GET:/v2/tenant/{tenantId}/workspace/{workspaceId}/fields
   * @secure
   */
  listFieldsForSpecifiedObjects = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * multi-param of $source:$obj1,$obj2,$obj3 of objects to query for
       * @minItems 1
       * @example ["DF:Company,Person","SF:Account,Case"]
       */
      objects: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapDataSourceArrayEnrichedDataObjectMetadataView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/workspace/${workspaceId}/fields`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listFieldsForSpecifiedObjects */
  listFieldsForSpecifiedObjectsPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /**
       * multi-param of $source:$obj1,$obj2,$obj3 of objects to query for
       * @minItems 1
       * @example ["DF:Company,Person","SF:Account,Case"]
       */
      objects: string[];
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/workspace/${workspaceId}/fields`, query);

  /**
   * @description list available objects for specified sources
   *
   * @tags Fields V2
   * @name ListAllAvailableObjects
   * @request GET:/v2/tenant/{tenantId}/objects
   * @secure
   */
  listAllAvailableObjects = (
    tenantId: string,
    query?: {
      /**
       * @minItems 1
       * @default ["SF"]
       * @example ["SF","DF"]
       */
      sources?: DataSource[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapDataSourceArrayLimitedDataObjectMetadataView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/objects`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAllAvailableObjects */
  listAllAvailableObjectsPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @minItems 1
       * @default ["SF"]
       * @example ["SF","DF"]
       */
      sources?: DataSource[];
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/objects`, query);

  /**
   * @description list available operators
   *
   * @tags Fields V2
   * @name ListOperators
   * @request GET:/v2/tenant/{tenantId}/fields/operators
   * @secure
   */
  listOperators = (
    tenantId: string,
    query?: {
      /**
       * @minItems 1
       * @default ["SF"]
       * @example ["SF","DF"]
       */
      sources?: DataSource[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapDataSourceArrayFieldOperators,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/fields/operators`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listOperators */
  listOperatorsPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @minItems 1
       * @default ["SF"]
       * @example ["SF","DF"]
       */
      sources?: DataSource[];
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/fields/operators`, query);

  /**
   * @description list available fields for specified sources and objects
   *
   * @tags Fields V2
   * @name DeprecatedListFieldsForSpecifiedObjects
   * @request GET:/v2/tenant/{tenantId}/fields
   * @deprecated
   * @secure
   */
  deprecatedListFieldsForSpecifiedObjects = (
    tenantId: string,
    query: {
      /**
       * multi-param of $source:$obj1,$obj2,$obj3 of objects to query for
       * @minItems 1
       * @example ["DF:Company,Person","SF:Account,Case"]
       */
      objects: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapDataSourceArrayEnrichedDataObjectMetadataView,
      | AnyDataObjectId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/fields`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deprecatedListFieldsForSpecifiedObjects */
  deprecatedListFieldsForSpecifiedObjectsPathGetter = (
    tenantId: string,
    query: {
      /**
       * multi-param of $source:$obj1,$obj2,$obj3 of objects to query for
       * @minItems 1
       * @example ["DF:Company,Person","SF:Account,Case"]
       */
      objects: string[];
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/fields`, query);
}
